import React from "react";
import ReactDOM from "react-dom";

// Router
import { BrowserRouter } from 'react-router-dom';

// Redux
import { Provider } from 'react-redux';
import configureStore from './store/configureStore';

// App
import App from "./App";

// Styles
import 'semantic-ui-css/semantic.min.css';
import "./index.css";

//IntlProvider
import { IntlProvider } from "react-intl";
import { addLocaleData } from "react-intl";
import locale_pt from 'react-intl/locale-data/pt';
import locale_es from 'react-intl/locale-data/es';
import locale_en from 'react-intl/locale-data/en';
import messages_pt from "./translations/pt.json";
import messages_es from "./translations/es.json";
import messages_en from "./translations/en.json";

const store = configureStore(); // You can also pass in an initialState here

//language translation
addLocaleData([...locale_pt, ...locale_es, ...locale_en]);
const messages = {
    'pt': messages_pt,
    'es': messages_es,
    'en': messages_en
};
var availableLangs = ['pt', 'es', 'en'];
let language = navigator.language.split(/[-_]/)[0];  // language without region code
if (!availableLangs.includes(language)){
    language = 'pt';//default language
}

ReactDOM.render(
    <Provider store={store}>
        <IntlProvider locale={language} messages={messages[language]}>
            <BrowserRouter>
                <App />
            </BrowserRouter>
        </IntlProvider>
    </Provider>, 
    document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js